import React from 'react';
import { Profile } from '../../Types';
import CSASummariesContent from './CSASummariesContent';
import { ViewContext } from './types';
import Column from '@amzn/meridian/column';

interface CSASummariesCSAViewProps {
  displayedProfile: Profile;
  viewContext: ViewContext;
  setParentExpanded: (result: boolean) => void;
}

const CSASummariesCSAView = ({
  displayedProfile,
  viewContext,
  setParentExpanded,
}: CSASummariesCSAViewProps) => {
  return (
    <Column>
      <CSASummariesContent
        displayedCsa={displayedProfile.user}
        viewContext={viewContext}
        spacingInset='500 none 400 none'
        setParentExpanded={setParentExpanded}
      />
    </Column>
  );
};

export default CSASummariesCSAView;
